
import { Component, Vue, Prop } from 'vue-property-decorator'
import HomeNewsTitle from './HomeNewsTitle.vue'

@Component({
  components: {
    HomeNewsTitle
  }
})
export default class extends Vue {
  @Prop() private titleText!: any
  @Prop() private infos!: string
  @Prop() private type!: string
  private showDialog = false

  private entries = [
    { img: require('@/assets/images/game-blue.png'), icon: require('@/assets/images/game-blue.png'), title: '技能大赛', otherIcon: require('@/assets/images/game-white.png') },
    { img: require('@/assets/images/training-blue.png'), icon: require('@/assets/images/training-blue.png'), title: '服务培训平台', otherIcon: require('@/assets/images/training-white.png'), url: 'https://train.tcwta.org.cn/' },
    { img: require('@/assets/images/tool-box-blue.png'), icon: require('@/assets/images/tool-box-blue.png'), title: '工具箱', otherIcon: require('@/assets/images/tool-box-white.png') },
    { img: require('@/assets/images/result-blue.png'), icon: require('@/assets/images/result-blue.png'), title: '成果评审', otherIcon: require('@/assets/images/result-white.png') }
  ]

  detail (item: any) {
    window.location.href = (`/infoNews.html#/news/${item.id}/${0}`)
  }

  dialogDetail (item: any) {
    if (item.url) {
      window.open(item.url)
    } else {
      this.showDialog = true
    }
  }

  mouseenter (item: any) {
    console.log(item)
    item.img = item.otherIcon
  }

  mouseleave (item: any) {
    console.log(item)
    item.img = item.icon
  }
}
